import { useEffect, useState } from 'react';
import Input from '../../ui/Input';
import Heading from '../../ui/Heading';
import Dropdown from '../../ui/Dropdown';
import Button from '../../ui/Button';
import RadioButtonComponent from '../../ui/RadioButtonComponent';
import OnSelectingPhysicalBounty from './OnSelectingPhysicalBounty';
import { bountyTypesWithIconData, coresWithIconData } from '../../constants/datas';
import Modal from '../../ui/Modal';
import CreateProjectModal from '../projects/CreateProjectModal';
import { getProjects, getProjectsCount } from '../../apis/projects/projects';
import { useLocation, useParams } from 'react-router-dom';
import { useStepOneInputs } from './bountiesHooks/useStepOneInputs';
import FormWithDescriptionField from '../../ui/RichTextInputForm';
import TextWithTooltip from '../../ui/TextWithTooltip';
import NotSelectedIcon from '../../assets/icons/NotSelectedIcon';
import FloatingButtons from '../../ui/FloatingButtons';
import CharacterLimit from '../../ui/CharacterLimit';
import TiptapEditor from './TipTapEditor';
import ButtonNew from '../../ui/ButtonNew';
import Loader from '../../ui/Loader';

const NewProject = ({ setProjectsAfterCreatingNewProject, selectAfterCreation }) => {
    return (
        <Modal>
            <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={'createproject'}>
                <Button type="button" variant="transparent" size="none">
                    + Create New Project
                </Button>
            </Modal.Button>
            <Modal.Window name={'createproject'}>
                <CreateProjectModal
                    from="bounty"
                    selectAfterCreation={selectAfterCreation}
                    setProjectsAfterCreatingNewProject={setProjectsAfterCreatingNewProject}
                />
            </Modal.Window>
        </Modal>
    );
};
function StepOne({
    setStep,
    saving,
    control,
    errors,
    getValues,
    clearErrors,
    descriptionLinkPayload,
    handleDescriptionLinkPayload,
    setRadiusPreview,
    projectEdit,
    bountyId,
    isFromEvent,
    onClickingYes,
    isDelete,
    isGreenpillEvent,
}) {
    const [projects, setProjects] = useState([]);
    const [content, setContent] = useState('');

    const location = useLocation();
    const { titleField, descriptionField, projectIdField, typeField, dominantCoreField, modeField } =
        useStepOneInputs(control);
    const { id } = useParams();
    const [selectedProject, setSelectedProject] = useState(() => {
        const searchParams = new URLSearchParams(location.search);

        // Decode the URL-encoded parameters
        const projectIdFromUrl = decodeURIComponent(projectEdit?.projectId || searchParams.get('projectId') || '');
        const projectTitleFromUrl = decodeURIComponent(
            projectEdit?.projectTitle || searchParams.get('projectTitle') || ''
        );
        // const foundProject = projects.find((project) => project.title === value);

        projectIdField.onChange(projectIdFromUrl);
        // setSelectedProject(value);
        return projectTitleFromUrl || '';
    });
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const countData = await getProjectsCount(id);
                    const count = countData?.entryCount || 0;
                    const data = count === 0 ? [] : await getProjects(id, 1, count);
                    setProjects(data);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [id]
    );
    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if Enter key is pressed and if focused element is an input, textarea, or select
            if (
                event.key === 'Enter' &&
                (document.activeElement.tagName === 'INPUT' ||
                    document.activeElement.tagName === 'TEXTAREA' ||
                    document.activeElement.tagName === 'SELECT')
            ) {
                event.preventDefault();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const handleSelectProject = (value) => {
        if (value === null) {
            projectIdField.onChange('');
            setSelectedProject('');
            return;
        }
        if (typeof value === 'object') {
            return;
        }
        if (value.toLowerCase() === 'no project') {
            projectIdField.onChange('');
            setSelectedProject('');
            return;
        }

        if (value.toLowerCase() === selectedProject.toLowerCase()) {
            projectIdField.onChange('');
            setSelectedProject('');
            return;
        }

        const foundProject = projects.find((project) => project.title === value);

        projectIdField.onChange(foundProject._id);
        setSelectedProject(value);
    };

    const handleSelectProjectAfterCreation = (value, id) => {
        projectIdField.onChange(id);
        setSelectedProject(value);
    };
    console.log(descriptionField?.value, 'descriptionField?.value');
    return (
        <div className="relative  min-h-full pb-44">
            <div className=" p-12 py-0    flex flex-col justify-between min-h-full    ">
                <div>
                    <div>
                        <Heading type="xsmall" className="capitalize text-textPrimary mb-1">
                            Bounty Title <sup className="text-lg relative top-[1px]">*</sup>
                        </Heading>

                        <Input
                            {...titleField}
                            error={errors?.title?.message}
                            placeholder={'Type your bounty’s title?'}
                            className={'w-[100%]'}
                        />
                        <CharacterLimit min={titleField.value ? titleField.value.length : 0} max={40} />
                    </div>

                    {/* <FormWithDescriptionField
                        handleDescriptionLinkPayload={handleDescriptionLinkPayload}
                        descriptionLinkPayload={descriptionLinkPayload}
                        errors={errors}
                        field={descriptionField}
                    /> */}
                    <div className="my-6">
                        <TextWithTooltip
                            containerClass="mb-1"
                            heading={
                                <Heading type="xsmall" className="capitalize text-textPrimary">
                                    Bounty Description<sup className="text-lg relative top-[1px]">*</sup>
                                </Heading>
                            }
                        >
                            <p className="text-sm">
                                Bounties are climate-positive tasks. The description should briefly describe what the
                                bounty is about, which will help users on Impact Miner.
                            </p>
                            <p className="mt-3 text-sm">
                                Bounties can range from providing proof of composting setup at home to building smart
                                contracts that can help fight climate change.
                            </p>
                        </TextWithTooltip>
                        <TiptapEditor
                            content={descriptionField?.value}
                            onChange={descriptionField?.onChange}
                            handleDescriptionLinkPayload={handleDescriptionLinkPayload}
                        />
                        {errors?.bountyDescription && (
                            <p className="text-red-500">{errors.bountyDescription.message}</p>
                        )}
                    </div>

                    {!isFromEvent && (
                        <div>
                            <TextWithTooltip
                                heading={
                                    <Heading type="xsmall" className="capitalize  text-textPrimary">
                                        Project
                                    </Heading>
                                }
                            >
                                <p className="text-sm">
                                    Projects are a group of bounties under an organisation with a specific objective. It
                                    is not required for a bounty to be under a project.
                                </p>
                                <p className="mt-3 text-sm">
                                    Projects help users find bounties with the same goals. For ex, you could have a
                                    project that just focuses on water scarcity and another project that focuses on
                                    water pollution
                                </p>
                            </TextWithTooltip>
                            <div className="relative">
                                <Dropdown
                                    w="w-full"
                                    noProject={projects?.length > 0 ? false : true}
                                    data={[
                                        <NewProject
                                            selectAfterCreation={handleSelectProjectAfterCreation}
                                            setProjectsAfterCreatingNewProject={setProjects}
                                        />,
                                        ...projects?.map((project) => project.title),
                                    ]}
                                    selected={selectedProject}
                                    onSelected={handleSelectProject}
                                    noSelectedText={
                                        <span className="flex items-center gap-[7px]">
                                            <span>Choose a project to link the bounty</span>
                                        </span>
                                    }
                                    error={errors?.projectId?.message}
                                />
                            </div>
                        </div>
                    )}
                    <div className="mt-6 flex gap-9  items-center ">
                        <div>
                            <div>
                                <TextWithTooltip
                                    heading={
                                        <Heading type="xsmall" className="capitalize  text-textPrimary">
                                            Bounty Type <sup className="text-lg relative top-[1px]">*</sup>
                                        </Heading>
                                    }
                                >
                                    <p className="text-sm">
                                        The bounty type hints users on the Impact Miner as to what the bounty is about.
                                        Users choose bounties based on their strengths, or as we say 'superpowers'.
                                    </p>
                                </TextWithTooltip>

                                <div className="relative">
                                    <Dropdown
                                        data={bountyTypesWithIconData.map((obj) => obj.label)}
                                        modifyLabel={(item) => {
                                            return (
                                                <span className="flex items-center gap-2">
                                                    {' '}
                                                    <span className="">
                                                        {
                                                            bountyTypesWithIconData?.find(
                                                                (obj) => obj.label.toLowerCase() === item.toLowerCase()
                                                            )?.icon
                                                        }
                                                    </span>{' '}
                                                    <span className='text-textPrimary'>{item}</span>{' '}
                                                </span>
                                            );
                                        }}
                                        modifySelected={(item) => {
                                            return (
                                                <span className="flex items-center gap-2">
                                                    {' '}
                                                    <span>
                                                        {
                                                            bountyTypesWithIconData?.find(
                                                                (obj) => obj.label.toLowerCase() === item.toLowerCase()
                                                            )?.icon
                                                        }
                                                    </span>{' '}
                                                    <span>{item}</span>{' '}
                                                </span>
                                            );
                                        }}
                                        selected={typeField.value}
                                        onSelected={typeField.onChange}
                                        noSelectedText={
                                            <span className="flex items-center gap-[7px]">
                                                <NotSelectedIcon /> <span>Choose Category</span>
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <TextWithTooltip
                                    heading={
                                        <Heading type="xsmall" className="capitalize  text-textPrimary">
                                            Dominant Impact Core <sup className="text-lg relative top-[1px]">*</sup>
                                        </Heading>
                                    }
                                >
                                    <p className="text-sm">
                                        Impact Cores is a framework that Atlantis has developed, that forms the basis of
                                        measuring impact.
                                    </p>
                                    <p className="text-sm mt-3">
                                        There are 4 types of Impact Cores, choose one that the bounty is majorly trying
                                        to solve for. Eg: the dominant impact core to map groundwater wells in a
                                        specific region would be water
                                    </p>
                                </TextWithTooltip>

                                <div className="relative">
                                    <Dropdown
                                        data={coresWithIconData.map((obj) => obj.label)}
                                        modifyLabel={(item) => {
                                            return (
                                                <span className="flex items-center gap-2">
                                                    {' '}
                                                    <span>
                                                        {
                                                            <img
                                                                className={` ${item.toLowerCase() === 'water' ||
                                                                    item.toLowerCase() === 'social'
                                                                    ? 'w-4 mr-1'
                                                                    : 'w-5 h-5'
                                                                    }  `}
                                                                src={
                                                                    coresWithIconData?.find(
                                                                        (obj) =>
                                                                            obj.label.toLowerCase() ===
                                                                            item.toLowerCase()
                                                                    )?.icon
                                                                }
                                                                alt="image"
                                                            />
                                                        }
                                                    </span>{' '}
                                                    <span className='text-textPrimary' >{item}</span>{' '}
                                                </span>
                                            );
                                        }}
                                        modifySelected={(item) => {
                                            return (
                                                <span className="flex items-center gap-2">
                                                    <img
                                                        className={` ${item.toLowerCase() === 'water' ||
                                                            item.toLowerCase() === 'social'
                                                            ? 'w-4 mr-1'
                                                            : 'w-5 h-5'
                                                            }  `}
                                                        src={
                                                            coresWithIconData?.find(
                                                                (obj) => obj.label.toLowerCase() === item.toLowerCase()
                                                            )?.icon
                                                        }
                                                        alt="image"
                                                    />
                                                    <span className='text-textPrimary'>{item}</span>{' '}
                                                </span>
                                            );
                                        }}
                                        selected={dominantCoreField.value}
                                        onSelected={dominantCoreField.onChange}
                                        noSelectedText={
                                            <span className="flex items-center gap-[7px]">
                                                <NotSelectedIcon /> <span>Choose Dominant Core</span>
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-9 mb-6 ">
                        <p className="text-foundryRed w-64 ">{errors?.type?.message && errors?.type?.message}</p>
                        <p className="text-foundryRed w-64 ">
                            {errors?.dominantCore?.message && errors?.dominantCore?.message}
                        </p>
                    </div>
                    <div className="my-6 ">
                        <TextWithTooltip
                            heading={
                                <Heading type="xsmall" className="capitalize  text-textPrimary">
                                    Bounty Mode
                                </Heading>
                            }
                        >
                            <p className="text-sm">
                                Digital Bounties are those bounties which a user can take up from anywhere in the world.
                                Eg: Providing ideas for a community outreach programme.
                            </p>
                            <p className="text-sm mt-3">
                                Physical bounties are those which require the user to be at a specific location for them
                                to accept and complete the bounty.
                            </p>
                        </TextWithTooltip>
                        <div className="flex gap-9 items-center ">
                            <RadioButtonComponent
                                selectedOption={modeField.value}
                                onSelectOption={(value) => {
                                    if (modeField.value === 'physical') {
                                        clearErrors('city');
                                        clearErrors('bountyRadius');
                                    }

                                    modeField.onChange(value);
                                }}
                                options={['digital', 'physical']}
                            />
                        </div>
                    </div>
                    {modeField.value === 'physical' && (
                        <OnSelectingPhysicalBounty
                            placeholder="Type in the location where the bounty should be available"
                            control={control}
                            core={dominantCoreField.value}
                            errors={errors}
                            getValues={getValues}
                            setRadiusPreview={setRadiusPreview}
                        />
                    )}
                </div>
            </div>

            <FloatingButtons>
                <div className="flex items-center gap-3">
                    <ButtonNew
                        type="button"
                        fixedMinWidth={true}
                        variant="neutral"
                        size="sm"
                        onClick={onClickingYes}
                        disabled={saving}
                    >
                        {saving ? <Loader /> : 'Save as Draft'}
                    </ButtonNew>
                </div>
                <ButtonNew
                    type="button"
                    fixedMinWidth={true}
                    variant="blue"
                    size="sm"
                    onClick={() => setStep(2)}
                >
                    Next
                </ButtonNew>
            </FloatingButtons>
        </div>
    );
}

export default StepOne;

// show newly project created left
